// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h4JogiwA_Qg8uw5qxn_I:not(.envUivI7SJofWLGMwCCx):hover>:first-child,.HULbycT_0TwgltRfjQEe>:first-child{background:var(--background-neutral-primary)}.B4E4t1wxTc2bS_sq9uB4{cursor:pointer;background:var(--background-primary-inverted-primary);border:none;border-radius:4px;max-width:100%;min-height:52px;padding:0;position:relative}.od36816j228cxotdk0LL{width:100%;max-width:288px}.od36816j228cxotdk0LL.ffrMHWmQm4wU8mPe0bBg{max-width:242px}.Y0zqtVdaUYQr4FQ38j12{width:-webkit-max-content;width:max-content;max-width:220px}.otZL0axPwPEP1jEUkyc8{width:-webkit-max-content;width:max-content}.Hwi7_FfQTdcSG6gzsxVN{padding-top:8px}.dUa6BO6An6IhN9NFX7AF{gap:4px;max-width:312px;display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonWrap": `h4JogiwA_Qg8uw5qxn_I`,
	"noteMode": `envUivI7SJofWLGMwCCx`,
	"detailsMode": `HULbycT_0TwgltRfjQEe`,
	"card": `B4E4t1wxTc2bS_sq9uB4`,
	"audio": `od36816j228cxotdk0LL`,
	"conversationsHistoryView": `ffrMHWmQm4wU8mPe0bBg`,
	"attachment": `Y0zqtVdaUYQr4FQ38j12`,
	"vcard": `otZL0axPwPEP1jEUkyc8`,
	"wrapPlayer": `Hwi7_FfQTdcSG6gzsxVN`,
	"videoAttachment": `dUa6BO6An6IhN9NFX7AF`
};
export default ___CSS_LOADER_EXPORT___;
